var module = angular.module('octopusApp.projects');
module.run(function (pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.AzureResourceGroup", function (octopusRepository, busy) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnServer,
            canChooseRoles: true,
            canHaveChildren: false,
            canBeChild: false,
            hasPackages: function(action) { return false; },
            summaryTemplateUrl: "areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_summary.html",
            editTemplateUrl: "areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup_edit.html",
            preLink: function (scope) {
                scope.account = {
                    AccountId: scope.action.Properties["Octopus.Action.Azure.AccountId"],
                    bound: {}
                };

                scope.resourceGroup = {
                    name: scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"],
                };

                scope.templateSource = {
                    usePackage: !!scope.action.Properties["Octopus.Action.Package.PackageId"]
                };

                scope.isAccountBound = function () {
                    return scope.account.bound.isBound;
                };

                scope.getAccountId = function () {
                    return (!scope.isAccountBound()) ? scope.action.Properties["Octopus.Action.Azure.AccountId"] : undefined;
                };

                scope.$watch(function () {
                        return scope.account.AccountId;
                    },
                    function () {
                        if (scope.action) {
                            scope.action.Properties['Octopus.Action.Azure.AccountId'] = scope.account.AccountId;
                        }
                    }
                );

                scope.$watch(function(){ return scope.resourceGroup.name; },
                    function(){
                        if (scope.action) {
                            scope.action.Properties["Octopus.Action.Azure.ResourceGroupName"] = scope.resourceGroup.name;
                        }
                    }
                );
            },

            editLink: function (scope) {
                scope.isLoading = busy.create();

                var unwatch = scope.$watch('action.Properties', function (nv) {
                    if (nv != null) {
                        if (!nv['Octopus.Action.Azure.TemplateSource']) {
                            nv['Octopus.Action.Azure.TemplateSource'] = "Inline";
                        }
                        unwatch();
                    }
                });

                scope.$watch('action.Properties["Octopus.Action.Azure.TemplateSource"]', function (templateSource, oldVal) {
                    if (!templateSource || (templateSource === oldVal)) {
                        return;
                    }

                    scope.action.Properties["Octopus.Action.Azure.ResourceGroupTemplate"] = undefined;
                    scope.action.Properties["Octopus.Action.Azure.ResourceGroupTemplateParameters"] = undefined;

                    if (templateSource === "Inline") {
                        scope.action.Properties["Octopus.Action.Package.PackageId"] = undefined;
                        scope.action.Properties["Octopus.Action.Package.FeedId"] = undefined;
                    }

                });

                scope.editorLoaded = function (editor) {
                    scope.editor = editor;
                    editor.$blockScrolling = Infinity;
                };
            }
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_resource_group/Octopus.AzureResourceGroup.js
// module id = 489
// module chunks = 1